export enum AppType {
  TPL = '3PL',
  CAPTAIN = 'Captain',
  CHARITY = 'Charity',
  ZENDESK = 'Zendesk',
  DRIVER = 'Driver',
}
